import DiamondFilled from './src/diamond-filled';
export default DiamondFilled;